import styled from 'styled-components'

import { Polygon } from 'components/polygon'
import { theme } from 'styles/theme'

const { media, space } = theme

export const ImageWrapper = styled.div`
  position: relative;
  width: 20.44rem;
  margin: 0 auto;
  padding-left: ${space['spacing-md']};

  @media (${media.desktop}) {
    width: 33.75rem;
  }
`

export const PinkPolygon = styled(Polygon)`
  position: absolute;
  top: 2.7rem;
  left: 0;
  width: 13.68rem;
  height: 14.75rem;

  @media (${media.desktop}) {
    top: 2.25rem;
    left: -${space['spacing-sm']};
    width: 23.125rem;
    height: 25.625rem;
  }
`

export const BluePolygon = styled(Polygon)`
  position: absolute;
  top: 3.4rem;
  left: 7.9rem;
  width: 13.68rem;
  height: 14.75rem;

  @media (${media.desktop}) {
    top: ${space['spacing-xxs']};
    left: 11.8125rem;
    width: 25.5rem;
    height: 27.375rem;
  }
`